import * as S from "../Style/Page/Home.style";
import HomeCenterLogo from "../assets/logo/symbol-logo.png";
import { Link } from "react-router-dom";
import HomeBgSecond from "../assets/image.png";

const Home = () => {
  return (
    <S.Home className={localStorage.getItem("language")}>
      <section className="section-home-first">
        <div className="wrap">
          <div className="inner">
            <div className="home-page-title">
              <div className="kor">영안모자 사업 소개</div>
              <div className="eng">Presentation of YoungAn Affiliates</div>
            </div>
            <Link to="/HatBusiness/Introduce">
              <img src={HomeCenterLogo} alt="" />
            </Link>
          </div>
        </div>
      </section>
      <section className="section-home-second">
        <img src={HomeBgSecond} alt="" />
      </section>
    </S.Home>
  );
};

export default Home;
